import { render } from "./HierarchyCreateWorkflowModal.vue?vue&type=template&id=3b37febe&scoped=true"
import script from "./HierarchyCreateWorkflowModal.vue?vue&type=script&lang=js"
export * from "./HierarchyCreateWorkflowModal.vue?vue&type=script&lang=js"

import "./HierarchyCreateWorkflowModal.vue?vue&type=style&index=0&id=3b37febe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b37febe"]])

export default __exports__